import { render, staticRenderFns } from "./OperationsTable.vue?vue&type=template&id=876c2d38&"
import script from "./OperationsTable.vue?vue&type=script&lang=js&"
export * from "./OperationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports